import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'

import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import { createColumns as createFavoriteColumns } from './columnsFavorite.columns.description'
import AthletesComponent from './component'

export default combine(
  withTableController({ id: 'athlete-table' }),
  withTableController({ id: 'favorite-athlete-table' }),
  withContext(
    'athleteService',
    ServicesContext,
    ({ athleteService }) => athleteService
  ),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withMemo('favoriteColumns', () => createFavoriteColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ athleteService }) =>
        async (tableState, _table, query) =>
          await athleteService.query({
            beneficiaryName: query?.beneficiaryName,
            categories: query?.categories,
            subCategories: query?.subCategories,
            page: tableState.page,
            size: tableState.pageSize,
          }),

      loadFavoriteAthlete:
        ({ followerService }) =>
        async (tableState) =>
          await followerService.getAthleteFollowers({
            page: tableState.page,
            size: tableState.pageSize,
          }),

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(AthletesComponent)
